const URLactual = window.location.href;
let result;
if(URLactual=='http://app3.bodeganet.cl/' || 
    URLactual=='https://app3.bodeganet.cl/' || 
    URLactual=='http://www.app3.bodeganet.cl/' ||
    URLactual=='https://www.app3.bodeganet.cl/'){
    result=true
} else {
    result=false
};
export default result